/**
 * 微信端公共登录体系
 * 整体流程：
 * 1、判断缓存是否有相应公众号的open_id（如果有则用open_id去请求"汶粤提供的接口"返回用户信息，流程结束）
 * 2、如果没有则优先进行静默授权请求get-wx-auth.json接口传入参数auth_type为"auto自动"获取到open_id（页面会刷新但不需要点按钮）
 * 3、使用2的open_id去请求"汶粤提供的接口"返回用户信息（如果系统中已有用户信息则返回用户信息，流程结束）
 * 4、如果3没返回用户信息则进行手动授权请求get-wx-auth.json接口传入参数auth_type为"manual手动"获取到open_id与union_id（页面会刷新且需要点按钮）
 * 5、使用4的open_id（前端将open_id长期本地缓存、供下次进入流程1中使用）与union_id去请求"汶粤提供的接口"返回用户信息（流程结束）
 *
 *
 */
import createHttp from '../tools/axios'
import { getRunningEnv } from '../tools/getPlatform'
import { getUrlParams } from '../tools/url'
let { env } = getRunningEnv()
let HOST = `https://m${env ? `-${env}` : ''}.xinli001.com`
let YIAPP_HOST = `https://yiapp${env ? `-${env}` : ''}.xinli001.com`
let api = {
  getWxAuth: `${HOST}/common/get-wx-auth.json`,
  weChatLogin: `${YIAPP_HOST}/commonWeChatLogin/weChatLogin`
}
class wechatLogin {
  constructor(
    name,
    { getWxAuthParams = {}, wechatGetUserParams = {}, ...commonData } = {}
  ) {
    this.name = name
    this.getWxAuthParams = getWxAuthParams
    this.wechatGetUserParams = wechatGetUserParams
    this.commonData = commonData

    this.$platform = require('../tools/getPlatform').getPlatform()
    this.getUrlParams = getUrlParams
    this.$http = createHttp()
    this.userInfo = null
    this.fetchWxAuthPromise = null
    if (this.initWechatLoginStatus()) {
      this.getWxAuth()
    }
  }
  initWechatLoginStatus() {
    if (
      this.$platform.isWechat &&
      window.sessionStorage.getItem('getWxAuth_auth_type')
    ) {
      let { code } = this.getUrlParams({
        type: 'search',
        params: ['code']
      })
      // 如果页面有code说明是刚授权回来的，需要自动请求接口
      return code
    }
  }
  remove_arg_from_url(query_string, nameList) {
    //如果没有参数则返回空
    if (query_string != undefined) {
      nameList.forEach(item => {
        var reg = new RegExp('(^|&)' + item + '=([^&]*)', 'g')
        query_string = query_string.replace(reg, '')
      })
      return query_string
    }
    return ''
  }
  // 微信授权(主动获取union_id，open_id\静默获取open_id)
  getWxAuth({ getWxAuthParams = {}, cache = true } = {}) {
    if (this.fetchWxAuthPromise && cache) {
      return this.fetchWxAuthPromise
    }
    let locationSearch = this.remove_arg_from_url(
      window.location.search.substr(1),
      ['code', 'state']
    )
    if (location.hash) {
      let hashStr = location.hash.substr(2)
      locationSearch = this.remove_arg_from_url(locationSearch, ['route'])
      locationSearch += '&route=' + encodeURIComponent(hashStr)
    }
    let { code } = getUrlParams({
      type: 'search',
      params: ['code']
    })
    var expectedUrl = location.origin + location.pathname + '?' + locationSearch
    let params = {
      name: this.name,
      code: code || '',
      redirect_url: expectedUrl,
      auth_type: 'manual'
    }
    params = Object.assign(params, this.getWxAuthParams, getWxAuthParams)

    // 重定向回来的以302重定向时使用的授权方式为准
    let getWxAuth_auth_type = window.sessionStorage.getItem(
      'getWxAuth_auth_type'
    )
    if (getWxAuth_auth_type) {
      params.auth_type = getWxAuth_auth_type
      window.sessionStorage.removeItem('getWxAuth_auth_type')
    }
    const _this = this
    return (this.fetchWxAuthPromise = this.$http
      .get(api.getWxAuth, {
        params
      })
      .then(({ data }) => {
        if (data.code === 302) {
          window.sessionStorage.setItem('getWxAuth_auth_type', params.auth_type)
          window.location.href = data.data.redirect_url
          return Promise.reject({
            code: 302,
            message: '请先注册登录，页面即将跳转...'
          })
        } else if (data.code === 0) {
          // 触发钩子函数
          const { hookGetWxAuthSuccess } = _this.commonData
          if (typeof hookGetWxAuthSuccess === 'function') {
            hookGetWxAuthSuccess(data.data)
          }

          let commonData = JSON.parse(
            window.localStorage.getItem('common_wechat_login')
          )
          if (!commonData) {
            commonData = {
              [this.name]: data.data.open_id
            }
          } else if (commonData[this.name] !== data.data.open_id) {
            commonData[this.name] = data.data.open_id
          }
          window.localStorage.setItem(
            'common_wechat_login',
            JSON.stringify(commonData)
          )
          return Promise.resolve(
            this.wechatFetchUserInfo({
              wechatGetUserParams: {
                unionId: data.data.union_id,
                openId: data.data.open_id
              }
            })
          )
        }
      }))
  }

  /**
   * 获取用户信息,用接口查询用户时候登录状态,不强制登录
   */
  wechatFetchUserInfo({ wechatGetUserParams = {} } = {}) {
    let params = {
      officialAccountName: this.name
    }
    switch (true) {
      case this.$platform.isWechat:
        params.channelId = 522
        break
      case this.$platform.isYixinliApp:
        params.channelId = 514
        break
      case this.$platform.isPc:
        params.channelId = 501
        break
      default:
        params.channelId = 513
    }
    // common_wechat_login //前端本地缓存公众号open_id的集合
    let commonData = JSON.parse(
      window.localStorage.getItem('common_wechat_login')
    )
    if (commonData && commonData[this.name]) {
      params.openId = commonData[this.name]
    }
    params = Object.assign(
      params,
      this.wechatGetUserParams,
      wechatGetUserParams
    )
    if (!params.openId) {
      console.log('请求用户信息失败，当前页面未登录、请求参数缺少openId')
      return Promise.reject({
        code: 5000,
        message: '请求用户信息失败，当前页面未登录、请求参数缺少openId'
      })
    }
    return new Promise((resolve, reject) => {
      this.$http
        .get(api.weChatLogin, { params })
        .then(({ data }) => {
          if (+data.code === 0) {
            this.userInfo = {
              ...data.data,
              collegeOpenid: data.data.openId
            }
            resolve(this.userInfo)
          } else {
            reject(data)
            // if (window.sessionStorage.getItem('getWxAuth_auto_manual') === 'auto') {
            //   console.log('静默授权获取用户信息失败')
            //   reject('静默授权获取用户信息失败')
            // } else {
            //   reject(this.getWxAuth({
            //     getWxAuthParams: {
            //       auth_type: 'manual'
            //     },
            //     cache: false
            //   }))
            // }
          }
        })
        .catch(err => {
          console.log('wechatFetchUserInfo.catch', err)
          reject(err)
        })
    })
  }
}
export default wechatLogin
